import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";

const advantages = {
    items: [
        {
            title: "Continuitatea activității fără întreruperi",
            text: "Intervențiile sunt planificate astfel încât procesele operaționale să se desfășoare fără blocaje sau timpi morți.",
        },
        {
            title: "Respectarea normelor de siguranță și igienă",
            text: "Lucrările sunt realizate conform procedurilor specifice mediilor industriale, contribuind la un spațiu de lucru sigur și organizat.",
        },
        {
            title: "Personal instruit pentru mediul industrial",
            text: "Echipele noastre sunt pregătite să lucreze în spații de mari dimensiuni, în proximitatea utilajelor și a zonelor cu trafic intens.",
        },
        {
            title: "Tehnologie și echipamente profesionale",
            text: "Utilizăm echipamente adecvate pentru curățenia industrială, asigurând eficiență și rezultate constante.",
        },
        {
            title: "Flexibilitate și adaptare la cerințele clientului",
            text: "Serviciile sunt adaptate specificului fiecărei locații, indiferent dacă este vorba despre întreținere zilnică sau intervenții speciale.",
        },
    ],
};

const advice = {
    paragraphs: [
        "Planificați curățenia industrială în funcție de fluxurile de lucru. Stabilirea unui program corelat cu activitatea reduce impactul asupra proceselor de producție și logistică.",
        "Nu amânați întreținerea pardoselilor industriale. Curățenia periodică și degresarea previn deteriorarea suprafețelor și reduc riscul de accidente.",
        "Acordați atenție zonelor cu trafic intens. Căile de acces, platformele și zonele de manipulare necesită întreținere constantă pentru siguranță și eficiență.",
        "Colaborați cu furnizori specializați în curățenie industrială. Experiența, organizarea și responsabilitatea legală sunt esențiale pentru lucrările de mari dimensiuni.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <ServiceGuidance advantages={advantages} advice={advice} />
            </Container>
        </MKBox>
    );
}

export default InformationHome;
